import { showVehicleDialogSelector } from 'Core/selectors/fitmentSearch/fitmentSearch.js';

export const extractorDataSelector = (state) => state.dialog.extractorData;

export function createDialogOpenedSelector(name) {
  return (state) =>
    name === 'VehicleWidgetDialog' ? showVehicleDialogSelector(state) : state.dialog.opened.includes(name);
}
